export default __webpack_public_path__ + "static/media/15g30mmn.b272d7e1.jpeg";